import React, { useCallback } from 'react';
import moment from 'moment';
import DayPicker from 'react-day-picker';
import 'react-day-picker/lib/style.css';
import Tippy from '@tippyjs/react';
import { Field } from '@ontruck/orc';
import { ReactComponent as CalendarIcon } from 'assets/icons/calendar.svg';
import styledCalendarField from './styled';

// for react-day-picker translations
// https://react-day-picker-v7.netlify.app/docs/localization
import MomentLocaleUtils from 'react-day-picker/moment';
import { injectIntl } from 'react-intl';

export const t = {
  label: 'Day to trigger',
};

export function formatDate(timestamp) {
  if (!timestamp) return '';
  return moment(timestamp).calendar(null, {
    lastDay: '[Yesterday]',
    sameDay: '[Today], DD MMM',
    nextDay: 'DD MMM',
    nextWeek: 'DD MMM',
    lastWeek: 'DD MMM',
    sameElse: 'DD MMM',
  });
}

const Calendar = ({ className, value, setValue, intl }) => {
  const handleDayClick = useCallback(
    (selectedDate) => {
      const newDate = new Date(value);

      newDate.setDate(selectedDate.getDate());
      newDate.setMonth(selectedDate.getMonth());
      newDate.setFullYear(selectedDate.getFullYear());

      setValue(newDate.toISOString());
    },
    [setValue, value]
  );

  return (
    <div className={className}>
      <Tippy
        theme="light"
        interactive
        trigger="click"
        maxWidth="none"
        content={
          <DayPicker
            localeUtils={MomentLocaleUtils}
            locale={intl.locale}
            selectedDays={new Date(value)}
            disabledDays={{ before: new Date() }}
            className="Selectable"
            onDayClick={handleDayClick}
            month={moment().toDate()}
          />
        }
      >
        <span className="field-container">
          <Field
            id="calendar_field"
            name="calendar_field"
            label={t.label}
            value={formatDate(value)}
            onChange={() => {
              /*noop*/
            }}
            asideRightText={<CalendarIcon />}
          />
        </span>
      </Tippy>
    </div>
  );
};

export default injectIntl(styledCalendarField(Calendar));
